<template>
    <div class="form-field-multi-select relative inline-block text-left" :ref="'dropdownDialog-' + name">
        <div>
            <button type="button" class="group inline-flex items-center justify-center text-sm font-medium text-gray-700 hover:text-gray-900" :aria-expanded="isOpen" @click="toggleDropdown">
                <span>{{label}}</span>
                <span v-if="selected?.length" class="ml-1.5 rounded bg-gray-200 px-1.5 py-0.5 text-sm font-semibold tabular-nums text-gray-700">{{selected.length}}</span>
                <svg class="-mr-1 ml-1 h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
                </svg>
            </button>
        </div>
        <div
            class="absolute left-0 z-10 mt-2 max-h-[400px] origin-top-right overflow-y-auto rounded-md bg-white p-4 shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none"
            :class="{
                'hidden': !isOpen,
            }"
        >
            <div class="space-y-4">
                <div class="flex cursor-pointer items-center" v-for="item in items" :key="item.value" :id="name + '-' + item.value" @click="toggle(item.value)">
                    <input :value="item.value" v-model="selected" type="checkbox" class="h-4 w-4 cursor-pointer rounded border-gray-300 text-sky-600 focus:ring-sky-500">
                    <label :for="name + '-' + item.value" class="ml-3 cursor-pointer whitespace-nowrap pr-6 text-sm font-medium text-gray-900">{{item.text}}</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormFieldMultiSelect',
    props: {
        name: {
            required: true,
            type: String,
        },
        label: {
            required: false,
            type: String,
            default: 'Select Options',
        },
        value: {
            required: false,
            type: Array,
            default: function () {
                return [];
            },
        },
        items: {
            required: false,
            type: Array,
            default: function () {
                return [
                    // {value: '', text: ''}
                ];
            }
        },
        condensed: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['input'],
    data () {
        return {
            isOpen: false,
            selected: this.value
        };
    },
    methods: {
        toggleDropdown () {
            this.isOpen = !this.isOpen;
        },
        toggle (value) {
            const isSelected = this.selected.includes(value);
            const selected = this.selected.filter(item => item !== value);
            if (!isSelected) selected.push(value);
            this.selected = selected;
            this.$emit('input', {name: this.name, value: this.selected});
        },
        handleClickOff (e) {
            const clickInThisItem = this.$refs['dropdownDialog-' + this.name].contains(e.target);
            if (!clickInThisItem) this.isOpen = false;
        },
        clear () {
            this.selected = [];
            this.isOpen = false;
            this.$emit('input', {name: this.name, value: this.selected});
        }
    },
    watch: {
        value (value) {
            this.selected = value;
        }
    },
    mounted () {
        window.addEventListener('click', this.handleClickOff);
    },
    beforeUnmount () {
        window.removeEventListener('click', this.handleClickOff);
    }
};
</script>
